import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 26, className = "", amount = 0.15 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLines({ lines, className = "", lineClass = "", delay = 0, stagger = 0.13 }) {
  const items = Array.isArray(lines) ? lines : [lines];
  return (
    <span className={`block ${className}`}>
      {items.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClass}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export default Reveal;
